import React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Item } from '../../common/snippets'
import * as sx from '../../common/stylesInline/report_daily_branch'
import * as id from './common/AcountingId'
import * as lb from './common/AcountingLables'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../common/dropDownOA'
import Datepicker from '../../common/datePicker'
import moment from 'moment'
import { RefreshSvg } from '../../common/svg/refresh'
import { SplitButton } from '../../common/SplitButton'
import { AcountingHeading } from './common/AcountingHeading'
import { appendToUrl, diffInMonths, focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../common/helper'
import { getOwnChildBranches, getReportBranchList } from '../../../store/reports/reports_action'
import { useEffect } from 'react'
import * as URL from '../Reports/oldReportsUrls'
import { getBranchConfigOrEwbillinfo, updateAlertError } from '../../../store/common/common_action'
import { GetRequest, PostRequest, PostRequestCachedV3 } from '../../common/api'
import { urls, xlCol } from '../../common/constants'
import { buildNewSummaryTableData, buildOldSummaryTableData, newSummaryColumns, oldSummaryColumns } from './CreditSummaryReportUtils'

const CreditSummaryReportNew = (props) => {
    const { data: { common, reports }, getOwnChildBranches, updateAlertError } = props
    const { ownChildBranches1 } = reports
    const { loginData, citywiseBranchList, roleRights } = common
    const reportName = 'Branch Credit Limit Summary'
    const [stateList, setStateList] = useState([])
    const [sourceCityList, setSourceCityList] = useState([])
    const [sourceBranchList, setSourceBranchList] = useState([])
    const [selState, setSelState] = useState([])
    const [selSourceCity, setSelSourceCity] = useState([])
    const [selSourceBranch, setSelSourceBranch] = useState()
    const [selView, setSelView] = useState({ id: 0, name: 'Old Summary' })
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [resetFlag, setResetFlag] = useState(false)
    const [filterSourceCityList, setFilterSourceCityList] = useState([])
    const [disableBtn, setDisableBtn] = useState(false)
    const viewList = [
        { id: 0, name: 'Old Summary' },
        { id: 1, name: 'New Summary' },
    ]

    useEffect(() => {
        focusElemnt(id.creditSummaryFromDate)
    }, [])

    useEffect(() => {
        if (!isEmpty(loginData)) {
            const branchData = {
                intUserID: loginData?.intUserID,
                intCompanyID: loginData?.intCompanyID,
                intIsActive: 1,
            }
            getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)
            setSelSourceBranch({ BranchName: loginData?.strBranchName, BranchID: loginData?.intBranchID })
        }
    }, [loginData])

    useEffect(() => {
        if (!isEmpty(roleRights)) {
            if (roleRights?.Table1?.[0]?.AllowViewAllBranchReport || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin) {
                const obj = {
                    intUserID: 0,
                    intCompanyID: loginData?.intCompanyID,
                    intBranchID: 0,
                    strBranchName: '',
                    strBranchCode: '',
                    intStateID: 0,
                    intCityID: 0,
                    intIsActive: 1,
                }
                PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, obj, true, 24 * 60 * 60 * 1000).then((res) => {
                    if (res.status === 'Success') {
                        const filteredList = res?.Data?.Table?.filter(item => item.IsCargoCreditLimit === 1);
                        setSourceBranchList(filteredList);
                    }
                })
            } else if (!roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport && roleRights?.Table1?.[0]?.AllowBranchInchargeRights) {
                const obj = {
                    CompanyID: loginData?.intCompanyID,
                    CityID: loginData?.intCityID,
                    UserID: loginData?.intUserID,
                    BranchID: loginData?.intBranchID,
                    Mode: 1,
                }
                GetRequest(urls.getReportBranchList, obj).then((res) => {
                    if (res.status == 'Success') {
                        setSourceBranchList(res?.Data?.Table)
                    }
                })
            } else {
                const obj = {
                    intUserID: 0,
                    intCompanyID: loginData?.intCompanyID,
                    intBranchID: 0,
                    strBranchName: '',
                    strBranchCode: '',
                    intStateID: 0,
                    intCityID: loginData?.intCityID,
                    intIsActive: 1,
                }
                PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
                    if (res.status === 'Success') {
                        const filteredList = res?.Data?.Table?.filter(item => item.IsCargoCreditLimit === 1);
                        setSourceBranchList(filteredList);
                    }
                })
            }
        }
    }, [roleRights, loginData])

    useEffect(() => {
        if (!isEmpty(roleRights) && !isEmpty(loginData)) {
            setDisableBtn(
                !(
                    roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
                    roleRights?.Table1?.[0]?.AllowBranchInchargeRights ||
                    loginData?.IsBranchAdmin ||
                    loginData?.IsMTPLAdmin ||
                    loginData?.IsAdmin
                )
            )
        }
    }, [roleRights, loginData])

    useEffect(() => {
        if (!isEmpty(ownChildBranches1)) {
            if (ownChildBranches1?.length > 0) {
                let data = []
                let data1 = []
                ownChildBranches1?.map((val, i) => {
                    data.push({ StateID: val?.StateID, StateName: val?.StateName })
                    data1.push({ CityName: val?.CityName, CityID: val?.CityID, StateID: val?.StateID })
                })
                setStateList(data)
                setSourceCityList(data1)
                setFilterSourceCityList(data1)
                setSelState({
                    StateName: ownChildBranches1.filter((obj) => obj.CityID === loginData?.intBranchCityID)[0]?.StateName,
                    StateID: ownChildBranches1.filter((obj) => obj.CityID === loginData?.intBranchCityID)[0]?.StateID,
                })
                setSelSourceCity({ CityName: loginData?.strCityName, CityID: loginData?.intBranchCityID })
            } else {
                setStateList([])
                setSourceCityList([])
                setSelState('')
                setSelSourceCity('')
            }
        }
    }, [ownChildBranches1])

    const getMainHeader = (columns = []) =>
        columns.map((col) => {
            const header = col.headerName || col.header || ''
            const columnXlCol = col.xlCol || xlCol

            return {
                ...col,
                header,
                exportHead: col.exportHead || header,
                xlCol: columnXlCol,
                align: col.align || (columnXlCol?.dataType === 'string' ? 'left' : 'right'),
                weight: col?.weight ?? 80,
            }
        })

    const criteriaHeaders = [
        { field: 'fromDate', header: 'From Booking Date', textAlign: 'left' },
        { field: 'toDate', header: 'To Booking Date', textAlign: 'left' },
        { field: 'company', header: 'Company', textAlign: 'left' },
        { field: 'state', header: 'State', textAlign: 'left' },
        { field: 'city', header: 'City', textAlign: 'left' },
        { field: 'branch', header: 'Branch', textAlign: 'left' },
    ]

    const buildCriteriaData = () => ([
        {
            fromDate: fromDate.format('DD-MMM-YYYY'),
            toDate: toDate.format('DD-MMM-YYYY'),
            company: loginData?.strCompanyName || '',
            state: selState?.StateName || '',
            city: selSourceCity?.CityName || '',
            branch: selSourceBranch?.BranchName || '',
            dataType: 'entry',
        },
    ])

    const openViewReport = (reportPayload) => {
        const rid = Date.now().toString()

        if (!window.generatedReports) {
            window.generatedReports = {}
        }

        window.generatedReports[rid] = reportPayload
        window.open(`/view-report?rid=${rid}`, '_blank')
    }

    const handleClick1 = async () => {
        if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
            updateAlertError({ show: true, msg: 'Selected Date Range is More Then One Month', nextId: '' })
            return
        }

        const obj = {
            intCompanyID: loginData?.intCompanyID,
            intBranchID: selSourceBranch?.BranchID,
            dtFromDate: fromDate.format('YYYY-MM-DD'),
            dtToDate: toDate.format('YYYY-MM-DD'),
            intUserID: loginData?.intUserID,
        }

        const res = await GetRequest(urls.getCreditSummaryData, obj)

        if (res?.status !== 'Success' || !res?.Data?.Table?.length) {
            updateAlertError({ show: true, msg: 'No Data Found', nextId: '' })
            return
        }

        const isNewSummary = selView.id === 1
        const tableData = (isNewSummary ? buildNewSummaryTableData(res.Data) : buildOldSummaryTableData(res.Data))
            .filter(Boolean)
            .map((row) => ({
                ...row,
                dataType: row?.dataType || 'entry',
            }))

        const reportPayload = {
            reportName: isNewSummary ? `${reportName} Cashbook Format` : `${reportName}`,
            criteriaHeaders,
            criteriaData: buildCriteriaData(),
            mainHeader: getMainHeader(isNewSummary ? newSummaryColumns : oldSummaryColumns),
            tableData,
            isIncreFontSize: true,
        }
        openViewReport(reportPayload)
    }

    const handleClick2 = () => {
        let url = URL.creditSummaryReport
        const urlData = URL.creditSummaryReportParams
        urlData.chk = loginData.BusCrsCheckSum
        urlData.intCompanyID = loginData?.intCompanyID
        urlData.intBranchID = loginData?.intBranchID
        urlData.intUserID = loginData?.intUserID
        urlData.dtfromDate = fromDate.format('DD-MMM-YYYY')
        urlData.dtToDate = toDate.format('DD-MMM-YYYY')
        urlData.selectedBranchName = selSourceBranch?.BranchName
        urlData.intAllowExportToExcel = 1
        url = appendToUrl(url, urlData)
        window.open(url, '_blank')
    }

    const handleStateChange = (stateId) => {
        if (stateId !== 0) {
            const filteredCities = sourceCityList.filter((val) => val.StateID === stateId)
            setFilterSourceCityList(filteredCities)
            setSelSourceCity(filteredCities?.[0] || ' ')
            const filteredBranch = removeDuplicatesFromArray(sourceBranchList, 'BranchID').filter((val) => val.CityID === filteredCities?.[0]?.CityID || filteredCities?.[0]?.CityID === 0 || val.BranchID === 0)
            setSelSourceBranch(filteredBranch?.[0] || ' ')
        } else {
            setFilterSourceCityList(sourceCityList)
        }
    }

    function addDaysToDate(date, days) {
        const newDate = new Date(date)
        newDate.setDate(newDate.getDate() + days)
        return newDate.toISOString().split('T')[0]
    }
    const selectedSourceCity = (obj) => {
        setSelSourceCity(obj)
        setSelSourceBranch(removeDuplicatesFromArray(sourceBranchList, 'BranchID').filter((item) => item.CityID === obj?.CityID || obj?.CityID === 0 || item.BranchID === 0)?.[0])
    }
    return (
        <>
            <Item sx={{ padding: '0' }} className="reports">
                <AcountingHeading reportName={reportName} />
                <Box sx={sx.reportFlex}>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            id={id.selectCompany}
                            label={lb.select_company}
                            defaultvalue={loginData.strCompanyName}
                            disabled={true}
                            minWidth="250px"
                            width="300px"
                        />
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
                            GO
                        </Button>
                    </Item>
                    <Item sx={sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            label={`From Booking Date`}
                            id={id.creditSummaryFromDate}
                            dateChange={(date) => {
                                setFromDate(date)
                                focusElemnt(id.toDate)
                            }}
                            startDate={'2022-01-01'}
                            endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
                        />
                    </Item>
                    <Item sx={sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            label={'To Booking Date'}
                            id={id.toDate}
                            dateChange={(date) => {
                                setToDate(date)
                                focusElemnt(disableBtn ? id.creditSummarySplitButton : id.stateId)
                            }}
                            startDate={'2022-01-01'}
                            endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
                        />
                    </Item>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            id={id.stateId}
                            label={'Select State'}
                            data={removeDuplicatesFromArray(stateList, 'StateID') || []}
                            defaultvalue={selState?.StateName}
                            idKey={`StateID`}
                            dataKey={`StateName`}
                            onSelect={(val) => {
                                setSelState(val)
                                handleStateChange(val.StateID)
                            }}
                            isObjArr={true}
                            width="310px"
                            nextId={id.srcCity}
                            prevId={id.toDate}
                            resetFlag={resetFlag}
                            disabled={disableBtn}
                        />
                    </Item>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            id={id.srcCity}
                            label={'Select City'}
                            data={removeDuplicatesFromArray(filterSourceCityList, 'CityID') || []}
                            defaultvalue={selSourceCity?.CityName}
                            idKey={`CityID`}
                            dataKey={`CityName`}
                            onSelect={(obj) => selectedSourceCity(obj)}
                            isObjArr={true}
                            searchPlaceholder={`Search By Report Type`}
                            width="310px"
                            nextId={id.srcBranch}
                            prevId={id.stateId}
                            resetFlag={resetFlag}
                            disabled={disableBtn}
                        />
                    </Item>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            id={id.srcBranch}
                            label={'Select Branch'}
                            data={removeDuplicatesFromArray(sourceBranchList, 'BranchID').filter(
                                (val) => val.CityID === selSourceCity?.CityID || selSourceCity?.CityID === 0 || val.BranchID === 0
                            ) || []}
                            defaultvalue={selSourceBranch?.BranchName || selSourceBranch}
                            idKey={`BranchID`}
                            dataKey={`BranchName`}
                            onSelect={(val) => {
                                setSelSourceBranch(val)
                            }}
                            isObjArr={true}
                            searchPlaceholder={`Search By Report Type`}
                            width="310px"
                            nextId={id.summaryView}
                            prevId={id.srcCity}
                            resetFlag={resetFlag}
                            disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
                        />
                    </Item>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            id={id.summaryView}
                            label={'Select View'}
                            data={viewList || []}
                            defaultvalue={selView?.name}
                            idKey={`id`}
                            dataKey={`name`}
                            onSelect={(val) => {
                                setSelView(val)
                            }}
                            isObjArr={true}
                            searchPlaceholder={`Search By Report Type`}
                            width="310px"
                            nextId={id.creditSummarySplitButton}
                            prevId={id.srcBranch}
                            resetFlag={resetFlag}
                            disabled={disableBtn}
                        />
                    </Item>
                    <Item
                        sx={sx.itemsx}
                        onKeyDown={(e) => navigation3(e, id.creditSummaryFromDate, () => handleClick1())}
                    >
                        <SplitButton
                            options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                            // hideToggle={false}
                            id1={id.creditSummarySplitButton}
                            prevID={disableBtn ? id.toDate : id.summaryView}
                            onClick1={handleClick1}
                            onClick2={handleClick2}
                        />
                    </Item>
                    <Item
                        sx={{ ...sx.itemsx }}
                        onClick={() => {
                            setResetFlag(!resetFlag)
                        }}
                    >
                        <RefreshSvg />
                    </Item>
                </Box>
            </Item>
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
    getOwnChildBranches,
    getBranchConfigOrEwbillinfo,
    getReportBranchList,
    updateAlertError,
}
export default connect(mapStateToProps, mapDispatchToProps)(CreditSummaryReportNew)
